import axios from 'axios';

export default {
  async storeWithUpload(fileName, formData) {
    try {
      const res = await axios.post(`/platform_stock/upload/${fileName}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return res.data.data;
    } catch (error) {
      console.error('上傳失敗:', error);
      throw error;
    }
  },
};